export enum GameAssetType {
  PileFoundation = 'pile_foundation',
  PileDeck = 'pile_deck',
  Pile = 'pile',
  CardBack = 'card_back',
  CardShadow = 'card_shadow',
  CardClub = 'card_club',
  CardDiamond = 'card_diamond',
  CardHeart = 'card_heart',
  CardSpade = 'card_spade',
  StartButton = 'start_button',
}

export enum GameSpriteType {
  NumbersLargePink = 'numbers_large_pink',
  NumbersLargeBlack = 'numbers_large_black',
  NumbersSmallPink = 'numbers_small_pink',
  NumbersSmallBlack = 'numbers_small_black',
}
